module.exports = __webpack_public_path__ + "static/media/copy_icon.aacb44bf.svg";